import sharedModule from '../../shared.module';

class surveyjsConverter {
    constructor() {}

    convert(surveyjsObject) {
        var asuiDynamicFormObject = {
            name: '',
            title: '',
            items: []
        };

        for (var pageIndex in surveyjsObject.pages) {
            var page = surveyjsObject.pages[pageIndex];
            asuiDynamicFormObject.subject = page.name;
            for (var elementIndex in page.elements) {
                var element = page.elements[elementIndex];
                var item = {
                    label: element.title,
                    name: element.name,
                    description: element.description,
                    model: '',
                    validation: {}
                };

                if (element.isRequired) {
                    item.validation.required = {
                        value: true,
                        message: element.requiredErrorText
                    };
                }

                if (element.validators) {
                    for (var validatorIndex in element.validators) {
                        var validator = element.validators[validatorIndex];
                        for (var validateIndex in validator) {
                            item.validation[validateIndex.toLowerCase()] = {
                                value: validator[validateIndex]
                            };
                        }
                    }
                }

                if (element.visible !== undefined) {
                    item.show = function() {
                        return element.visible;
                    };

                    if (
                        element.visibleIf &&
                        asuiDynamicFormObject.items &&
                        asuiDynamicFormObject.items.length > 0
                    ) {
                        var condition = this.getCondition(
                            element.visibleIf,
                            asuiDynamicFormObject.items
                        );

                        item.show = function(items) {
                            return new Function('items', `return ${condition}`)(
                                items
                            );
                        };
                    }
                }

                switch (element.type.toLowerCase()) {
                    case 'text':
                        item.type = 'textbox';
                        break;
                    case 'dropdown':
                        this.convertDropdown(element, item);
                        break;
                    case 'comment':
                        this.convertComment(element, item);
                        break;
                    case 'file':
                        this.convertFile(element, item);
                        break;
                }
                asuiDynamicFormObject.items.push(item);
            }
        }

        return asuiDynamicFormObject;
    }

    convertDropdown(element, item) {
        item.type = 'dropdown';
        item.items = [
            {
                label: 'Choose...'
            }
        ];
        for (var choiceIndex in element.choices) {
            var choice = element.choices[choiceIndex];
            if (typeof choice === 'string') {
                item.items.push({
                    label: choice,
                    value: choice
                });
            } else {
                item.items.push({
                    value: choice.value,
                    label: choice.text
                });
            }
        }
        item.model = element.defaultValue;
    }

    convertComment(element, item) {
        item.type = 'richtext';
        item.options = {
            sticky: true
        };
        item.model = { html: '', text: '' };
    }

    convertFile(element, item) {
        item.type = 'file';
        item.options = {
            singleFile: true,
            showThumbnail: false,
            autoReplace: true,
            autoUpload: false
        };
        item.onFileAdded = file => {
            item.file = file.file;
            var reader = new FileReader();
            reader.onload = e => {
                item.model = e.target.result;
            };
            reader.readAsDataURL(file.file);
        };
        item.onDelete = file => {
            if (file) {
                item.file = null;
                item.model = null;
            }
        };
        item.validation.maxsize = {
            value: element.maxSize
        };
    }

    getCondition(input, items) {
        var conditionalRegex = /[\s]*(\(*)[\s]*('[^']+'|[^|&\s]|\{[^{}']+\}|\d+)[\s]*(notempty|empty|>=|greaterorequal|<=|lessorequal|==|=|equal|<>|!=|notequal|>|greater|<|less|notcontains|contains)[\s]*('[^']+'|\{[^{}']+\}|\d+)?[\s]*(\)*)[\s]*(\||\|\||&&|&|and|or)?[\s]*/gi; // 0: overall // 1: opening bracket // 2: left condition // 3: operand // 4: right condition (optional) // 5: closing bracket // 6: and or operator
        var allResult = '';
        var validationString = '';
        var result = conditionalRegex.exec(input);
        while (result) {
            var left = this.getObjectValue(result[2], items);
            var operand = result[3];
            var right = this.getObjectValue(result[4], items);
            if (!operand || left == undefined) {
                break;
            }

            operand = operand.toLowerCase();
            var conditionResult;

            switch (operand) {
                case 'empty':
                    conditionResult = `${left} == ''`;
                    break;
                case 'notempty':
                    conditionResult = `${left} != ''`;
                    break;
                case '=':
                case '==':
                case 'equal':
                    conditionResult = `${left} == ${right}`;
                    break;
                case '<>':
                case '!=':
                case 'notequal':
                    conditionResult = `${left} != ${right}`;
                    break;
                case '>':
                case 'greater':
                    conditionResult = `${left} > ${right}`;
                    break;
                case '<':
                case 'less':
                    conditionResult = `${left} < ${right}`;
                    break;
                case '>=':
                case 'greaterorequal':
                    conditionResult = `${left} >= ${right}`;
                    break;
                case '<=':
                case 'lessorequal':
                    conditionResult = `${left} <= ${right}`;
                    break;
                case 'contains':
                    conditionResult = `${left}.includes(${right})`;
                    break;
                case 'notcontains':
                    conditionResult = `!${left}.includes(${right})`;
                    break;
            }

            if (!conditionResult) {
                break;
            }

            var opening = result[1];
            var closing = result[5];
            var end = this.getEndOperator(result[6]);
            validationString += result[0];
            if (input.indexOf(validationString) != 0) {
                break;
            }

            allResult += ` ${opening}${conditionResult}${closing} ${end}`;
            result = conditionalRegex.exec(input);
        }

        if (input != validationString) {
            return null;
        }

        return allResult;
    }

    getEndOperator(end) {
        if (!end) {
            return '';
        }
        end = end.toLowerCase();
        switch (end) {
            case 'and':
            case '&':
            case '&&':
                return '&&';
            case 'or':
            case '|':
            case '||':
                return '||';
            default:
                return '';
        }
    }

    getObjectValue(input, items) {
        var result = /\{([^{}']+)\}/.exec(input);
        if (result) {
            return `items[${this.getItemIndex(items, result[1])}].model`;
        }

        return input;
    }

    getItemIndex(items, name) {
        if (items == undefined) {
            return null;
        }

        for (var itemIndex in items) {
            var itemObj = items[itemIndex];
            if (itemObj.name == name) {
                return itemIndex;
            }
        }
        return null;
    }
}

export default sharedModule.service('surveyjsConverter', surveyjsConverter);



// WEBPACK FOOTER //
// ./modules/shared/services/surveyjsConverter/surveyjsConverter.service.js